










import Vue from 'vue'
import { AppModule } from '@/store/modules/app'
import { Component, Watch, Mixins } from 'vue-property-decorator'
import ImageUpload from '@/components/products/malennachzahlen/PaintingByNumbersImageUpload.vue'
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'
import PaintingByNumbersSingleAssetUpload from '@/components/products/malennachzahlen/util/PaintingByNumbersSingleAssetUpload'
import { CollageClipper } from '@/components/products/malennachzahlen/util/paintingClipper'
import { PaintingByNumbersAssetUsage } from '@/components/products/malennachzahlen/util/paintingByNumbersAssetUsage'
import { AssetsModule } from '@/store/modules/asset'
import { PaintingByNumbersModule, PaintingInfo, PaintingFormat, PaintingBoxUpdateState } from '@/store/modules/paintingByNumbers'
import { AssetFile, SingleAssetUsage, BoundingBox, Point } from '@/store/modules/asset'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import updateAssetAttributes from '@/components/products/malennachzahlen/util/assetAttributesUpdateUtil'

@Component({
    name: 'painting-image-upload',
    components: { PrimaryButtons, ImageUpload }
})
export default class PaintingImageUpload extends Mixins(PaintingByNumbersSingleAssetUpload) {
    private oldSelectedAssetId: string = ''

    doConfirm(asset?: AssetFile, imageClipper?: CollageClipper, usage?: SingleAssetUsage): boolean{
        if (asset && asset.assetId && usage && imageClipper) {
            let info: PaintingInfo =  new PaintingInfo(asset.assetId as number, imageClipper.boundingBox as BoundingBox, usage.rotation as number, false)
            if(PaintingByNumbersModule.paintingUsageAndInfo[imageClipper.usageName!] == undefined || info.attributesChanged(PaintingByNumbersModule.paintingUsageAndInfo[imageClipper.usageName!])) {
                info.attributesNeedUpdate = true
            }
            PaintingByNumbersModule.SetPaintingInfo(info)
            if (asset.assetId.toString() !== this.oldSelectedAssetId && this.oldSelectedAssetId !== '') {
                this.resetStepTwoToFour()
            }
            if(info.attributesNeedUpdate == true) {
                PaintingByNumbersModule.SetPaintingBoxUpdateState(PaintingBoxUpdateState.UPDATING_ASSET_ATTRIBUTES)
            }
            this.$nextTick(() => {
                updateAssetAttributes().then(
                    (value) => {
                        //nothing
                    },
                    (reason) => {
                        window.console.log(reason)
                    });
            })
            return true
        } else if (this.oldSelectedAssetId !== '') {
            this.resetStepTwoToFour()
            let key = "paintingimage"
            let info = PaintingByNumbersModule.paintingUsageAndInfo[key]
            if (info) {
                PaintingByNumbersModule.ClearAllCollages(key)
            }
        }
        return true
    }

    get confirmable(): boolean {
        return this.asset !== undefined
    }

    get selectedAssets() {
        return AssetsModule.selectedAssets
    }

    mounted() {
        let usageName = "paintingimage"
        let asset = PaintingByNumbersModule.activeAssets[usageName]
        if (asset && asset.assetId) {
            PaintingByNumbersAssetUsage.prepareCollageUsage(asset, usageName)
            AssetsModule.Select(asset)
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
            this.asset = asset
            this.oldSelectedAssetId = asset.assetId.toString()
        }
        this.persistPuzzle()
        if (Object.keys(PaintingByNumbersModule.activeAssets).length === 0 && AssetsModule.selectedAssets.length !== 0) {
            AssetsModule.Select()
        }
    }

    resetStepTwoToFour(){
        AppModule.ResetSteps(true)
        PaintingByNumbersModule.SetPaintingFormat(PaintingFormat.LANDSCAPE)
        PaintingByNumbersModule.SetBoxDesign(1)
        PaintingByNumbersModule.SetBoxDesignCategory(0)
        PaintingByNumbersModule.SetTitle('')
        PaintingByNumbersModule.SetUserInputTitle('')
        PaintingByNumbersModule.SetUserFormat('')
        PaintingByNumbersModule.SetStepsReseted(!PaintingByNumbersModule.stepsReseted)
    }

    persistPuzzle() {
        Object.keys(PaintingByNumbersModule.persistedAssets).forEach(key => {
            PaintingByNumbersModule.ClearPersistedAssetData(key)
        })
        Object.keys(PaintingByNumbersModule.activeAssets).forEach(key => {
            let asset = PaintingByNumbersModule.activeAssets[key]
            let usage = asset.usage[key] as SingleAssetUsage
            let info = PaintingByNumbersModule.paintingUsageAndInfo[key] as PaintingInfo
            if (info !== undefined && usage !== undefined && asset !== undefined) {
                PaintingByNumbersModule.SetPersistedAsset([key, asset])
                PaintingByNumbersModule.PersistNameAndUsage([key, usage])
                PaintingByNumbersModule.PersistPaintingUsageAndInfo([key, info])
            }
        })
    }
}
